module.exports = __webpack_public_path__ + "img/first_bg03.95292e1b.png";